import { IconBase, IconComponent } from './BaseIcon';

export const LayerDown: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M19 13V2H2v17h11v11h17V13Zm-4.29 0L17 10.71V13ZM4 4h2.29L4 6.29Zm0 3.71L7.71 4h2.58L4 10.29Zm0 4L11.71 4h2.58L4 14.29ZM4 17v-1.29L15.71 4H17v1.29L5.29 17Zm2.71 0L17 6.71v2.58L13.29 13H13v.29L9.29 17Zm4 0L13 14.71V17ZM28 28H15V15h13ZM24 8V5.41l4.29 4.3 1.42-1.42L25.41 4H28V2h-6v6h2z" />
  </IconBase>
);
